
  <h2 class="modal-question">
    {{ 'MODAL.HEADER.PRIVACYPOLICYQUESTION' | translate }}
  </h2>

  <p class="modal-subtitle">
    {{ message | translate }}
  </p>

  <div class="qr-wrapper ion-margin-vertical">
    <qrcode
      [qrdata]="url()"
      [width]="180"
      [errorCorrectionLevel]="'M'">
    </qrcode>
  </div>

  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size="5">
        <ion-button expand="block"
         color="success"
          (click)="close(true)">
          {{ 'BTN.OK' | translate }}
        </ion-button>
      </ion-col>
  
      <ion-col size="1"></ion-col>
  
      <ion-col size="5">
        <ion-button expand="block"
         color="dark"
          (click)="close(false)">
          {{ 'BTN.NO' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>